var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"info-wrapper"},[_c('div',{staticClass:"copyright"},[_c('p',{staticClass:"top-line"},[_c('i',{staticClass:"logo"}),_vm._v(" Copyright 2015-"+_vm._s(_vm.date)+" 深圳市迷你玩科技有限公司 , All Rights Reserved. ")]),_c('p',{staticClass:"bottom-line"},[_vm._v(" 《网络文化经营许可证》 浙粤网文[2016]1349-302号 ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }